export const OPEN_PANEL = "OPEN_PANEL";
export const CLOSE_PANEL = "CLOSE_PANEL";

export const SET_EXPANDED_ID = "SET_EXPANDED_ID";
export const SET_PREVIEW_IMAGE = "SET_PREVIEW_IMAGE";
export const CLEAR_ACTIVE_PREVIEW = 'CLEAR_ACTIVE_PREVIEW'
export const MARK_AS_READ = "MARK_AS_READ";
export const SET_ACTIVE_PREVIEW = "SET_ACTIVE_PREVIEW"
